import Typography, { TypographyProps } from '@mui/material/Typography';
import { styled, SxProps, Theme } from '@mui/material/styles';

export interface TitleProps {
  textTitle?: string;
  span?: React.ReactNode;
  id?: string;
  variant?: TypographyProps['variant'];
  sx?: SxProps<Theme>;
}

const TitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem',
    textAlign: 'center',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '1.25rem',
    textAlign: 'center',
  },
}));

// Styled components avec objets CSS (plus fiable que template literals)
const StyledTitle = styled(Typography)(() => ({
  color: 'rgb(54, 54, 54)',
  padding: '0.4em 0',
  width: '100%', // Prend toute la largeur du container parent
}));

const StyledSpan = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main, // Fallback si blue[60] n'existe pas
  // Ou si vous avez une palette personnalisée :
  // color: theme.palette.blue?.[60] || theme.palette.primary.main,
}));

const Title = ({ textTitle, span, id, variant = 'heading4', sx }: TitleProps) => {
  return (
    <TitleContainer>
      <StyledTitle
        variant={variant} // ✅ Variant MUI standard
        id={id}
        component="h2" // Sémantique HTML correcte
        sx={sx}
      >
        {textTitle}
      </StyledTitle>
      <StyledSpan
        variant="heading5" // ✅ Variant MUI standard
        component="span" // Évite les problèmes de nesting h1 > h2
      >
        {span}
      </StyledSpan>
    </TitleContainer>
  ) as React.ReactElement;
};

export default Title;
export { Title };
